import React, { Component } from 'react';

import { func, string } from 'prop-types';

import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import { Switch, Route, Link, withRouter } from 'react-router-dom';

import { Menu, Container, Responsive } from 'semantic-ui-react';
import { flowRight as compose, isEqual, isEmpty } from 'lodash'

import { TYPES_QUERY, INTROSPECTION_QUERY } from '../../graphql/introspectionQuery';

import HeaderComponent from '../Header';
import Overview from '../../routes/Overview'
import Reference from '../../routes/Reference'
import Explorer from '../../routes/Explorer'
import LoginModal from '../Modals/LoginModal'
import Changelog from '../../routes/Changelog'

import { setMatch, clickPointingMenuItem } from './appSlice'

class App extends Component {
  state = {
    overview: [],
    reference: [],
    visible: false,
    validToken: undefined,
    openLoginModal: false
  };

  static propTypes = {
    click: func,
    menu: string
  };

  handleItemClick = (e, { name }) => {
    this.props.click(name);
  };

  handleOpenLoginModal = (event) => {
    if (event.ctrlKey && event.altKey) {
      this.setState({ openLoginModal: true })
    }
  }

  handleCloseLoginModal = () => {
    this.setState({ openLoginModal: false })
  }

  onLogin = () => {
    if (!localStorage.getItem('Visp.token')) {
      return true;
    } else {
      return false;
    }
  };

  render = () => {
    const { types, location, queryFields, mutationFields, match, setMatch, reduxMatch, changelog } = this.props;
    const { openLoginModal } = this.state;
    const { pathname } = location;
    const path = pathname.split('/');

    if (!isEqual(reduxMatch, match)) {
      setMatch(match)
    }

    return (
      <div style={{ position: 'relative', minHeight: '100vh' }}>
        <LoginModal open={openLoginModal} onClose={this.handleCloseLoginModal} />
        <HeaderComponent
          types={types}
          queries={queryFields}
          mutations={mutationFields}
        />
        <Container style={{ paddingTop: '50px', paddingBottom: '50px' }}>
          <Menu size='small' secondary pointing>
            <Menu.Item position='left' onClick={(e) => this.handleOpenLoginModal(e)}>GraphQL API v4</Menu.Item>
            <Menu.Menu position='right'>
              <Menu.Item
                as={Link}
                to='/overview'
                name='overview'
                position='right'
                active={pathname === '/' || pathname === '/overview'}
                color='blue'
                onClick={this.handleItemClick}
              >
                Overview
              </Menu.Item>
              <Menu.Item
                as={Link}
                to='/reference'
                name='reference'
                position='right'
                active={
                  pathname === '/reference' || path[1] === 'reference'
                }
                color='blue'
                onClick={this.handleItemClick}
              >
                Reference
              </Menu.Item>
              <Menu.Item
                as={Link}
                to='/explorer'
                name='explorer'
                position='right'
                active={pathname === '/explorer'}
                color='blue'
                onClick={this.handleItemClick}
              >
                Explorer
              </Menu.Item>
              {!isEmpty(changelog) && (
                <Menu.Item
                  as={Link}
                  to='/changelog'
                  position='right'
                  active={pathname === '/changelog'}
                  color='blue'
                  onClick={this.handleItemClick}
                >
                  Changelog
                </Menu.Item>
              )}
            </Menu.Menu>
          </Menu>
          <Switch>
            <Route exact path='/' component={Overview} />
            <Route path='/overview' component={Overview} />
            <Route path='/reference' component={Reference} />
            <Route path='/explorer' component={Explorer} />
            <Route path='/changelog' component={Changelog} />
            {/* <PrivateRoute
              authed={this.onLogin()}
              path='/reference'
              component={Reference}
            />
            <PrivateRoute
              authed={this.onLogin()}
              path='/explorer'
              component={Explorer}
            />
            <Route
              render={() => <Header as='h1'>Url Not Available</Header>}
            /> */}
          </Switch>
        </Container>

        <Menu
          fluid
          borderless
          // attached='bottom'
          size='small'
          style={{
            left: 0,
            bottom: 0,
            height: 75,
            position: 'absolute'
          }}
        >
          <Container>
            <Menu.Item>@ 2017 VISP Inc., All rights reserved.</Menu.Item>

            <Menu.Menu position='right'>
              <Menu.Item>
                <Responsive {...Responsive.onlyComputer}>
                  Terms of Service
                    </Responsive>
              </Menu.Item>
              <Menu.Item>
                <Responsive {...Responsive.onlyComputer}>
                  Privacy
                    </Responsive>
              </Menu.Item>
              <Menu.Item>
                <Responsive {...Responsive.onlyComputer}>
                  Security
                    </Responsive>
              </Menu.Item>
              <Menu.Item>
                <Responsive {...Responsive.onlyComputer}>
                  Support
                    </Responsive>
              </Menu.Item>
            </Menu.Menu>
          </Container>
        </Menu>
      </div>
    );
  };
}

const mapStateToProps = state => ({
  menu: state.app.menu,
  reduxMatch: state.app.match,
  changelog: state.changelog,
});

const mapDispatchToProps = dispatch => ({
  click: item => dispatch(clickPointingMenuItem(item)),
  setMatch: item => dispatch(setMatch(item))
});

const types = graphql(TYPES_QUERY, {
  props: ({ data: { __schema, loading } }) => ({
    types: __schema && __schema.types
  })
});

const queryFields = graphql(INTROSPECTION_QUERY, {
  options: ({ ownProps }) => ({
    variables: { type: 'Query' }
  }),
  props: ({ data: { __type } }) => ({
    queryFields: __type && __type.fields
  })
});

const mutationFields = graphql(INTROSPECTION_QUERY, {
  options: ({ ownProps }) => ({
    variables: { type: 'Mutation' }
  }),
  props: ({ data: { __type } }) => ({
    mutationFields: __type && __type.fields
  })
});

export default withRouter(
  compose(
    connect(
      mapStateToProps,
      mapDispatchToProps
    ),
    types,
    queryFields,
    mutationFields
  )(App)
);